import React from "react";
import "./TrainerCard.scss";

const TrainerCard = () => {
  return (
    <div className="trainer-container">
      <h2 className="trainer-title">Poznaj swojego instruktora</h2>
      <div className="trainer-card">
        <div className="trainer-info">
          <h5 className="trainer-name">Tomasz Kaźmierczak</h5>
          <p className="trainer-description">
            Jestem praktykiem i specjalistą z kilkuletnim doświadczeniem we
            wdrażaniu rozwiązań teleinformatycznych dla polskich firm.
            <br />
            <br />
            Pewnie część z Was kojarzy już moją działalność na You Tube, z bloga
            Netadminpro.pl. <br />
            Z niektórymi z Was miałem nawet okazję porozmawiać i podpowiedzieć,
            jak ja bym postąpił w konkretnej sytuacji zawodowej.
            <br />
            <br />
            Nigdy nie przestaję się rozwijać, bo to lubię :) Dodatkowo wiem, że
            w naszej branży ciągłe doskonalenie się jest kluczowe. <br />
            Staram się być blisko praktyki, dlatego też wykonuję wdrożenia w
            różnych środowiskach, aby lepiej zrozumieć konkretne konfiguracje.{" "}
            <br />
            <br />
            Uważam, że praktyka jest najcenniejsza. A ponieważ moja jest już
            całkiem bogata, to mogę dzielić się nią i uczyć, jak unikać błędów,
            które sam kiedyś popełniłem.
            <br />
            <br />
            Dzięki temu kursowi Ty również możesz skorzystać z moich doświadczeń
            i osiągnąć jeszcze więcej.
          </p>
          {/* <div className="trainer-certificates">
            <img
              src="certyfikaty.png"
              alt="Certyfikaty"
              className="certificates-image"
            />
          </div> */}
        </div>
        <div className="trainer-avatar">
          <div
            className="avatar-image"
            style={{
              backgroundImage: "url('instruktor.png')",
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default TrainerCard;
